module.exports = __webpack_public_path__ + "img/award04_10.1c36d454.png";